import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import {
	ACKNOWLEDGE_NOTIFICATION_MUTATION,
	FIND_UNACKNOWLEDGED_NOTIFICATIONS_QUERY,
} from '@app/model/site_notification/service/SiteNotificationGraphQLQueries';
import SiteNotification from '@app/model/site_notification/SiteNotification';
import Return from '@app/model/_common/Return';

class SiteNotificationService {

	public static findUnacknowledgedNotifications(companyHotelId: number) {
		return GraphQLExecutor.execute<SiteNotification[]>(FIND_UNACKNOWLEDGED_NOTIFICATIONS_QUERY, { companyHotelId });
	}

	public static acknowledge(notificationId: number) {
		return GraphQLExecutor.execute<Return>(ACKNOWLEDGE_NOTIFICATION_MUTATION, { notificationId: notificationId });
	}
}

export default SiteNotificationService;